<template>
  <header class="header">
    <SectionContentWrapper>
      <div class="logos">
      <a class="logo-link" href="https://autopay.pl/" title="Strona Autopay">
      </a>
    </div>
    </SectionContentWrapper>
  </header>
</template>

<script>
import SectionContentWrapper from '../../../components/common/SectionContentWrapper'
export default {
  name: 'Header',
  components: {
    SectionContentWrapper
  }
}
</script>

<style lang="scss" src="../../../assets/scss/components/_header.scss"></style>
